import { Lexer, type Tokens } from 'marked';

export type MarkdownTableSegment =
  | { kind: 'text'; text: string }
  | { kind: 'table'; header: string[][]; rows: string[][][] };

const cellLines = (cell: Tokens.TableCell): string[] =>
  cell.text.replace(/\\\\/g, '\\').split(/<br\s*\/?>/i);

export function splitMarkdownTables(markdown: string): MarkdownTableSegment[] {
  const tokens = Lexer.lex(markdown);
  if (!tokens.some((token) => token.type === 'table'))
    return [{ kind: 'text', text: markdown }];

  const segments: MarkdownTableSegment[] = [];
  let text = '';
  const flushText = () => {
    const trimmed = text.replace(/^\n+|\n+$/g, '');
    if (trimmed) segments.push({ kind: 'text', text: trimmed });
    text = '';
  };
  for (const token of tokens) {
    if (token.type !== 'table') {
      text += token.raw;
      continue;
    }
    flushText();
    const { header, rows } = token as Tokens.Table;
    segments.push({
      kind: 'table',
      header: header.map(cellLines),
      rows: rows.map((row) => row.map(cellLines)),
    });
  }
  flushText();
  return segments;
}
